module.exports = __webpack_public_path__ + "images/b8416f2ce40a5a9a5c5323dac0cdcb2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-locations02.jpg
// module id = ./webpack/assets/img/diaryofanant-locations02.jpg
// module chunks = 0